import { breakpoints, g } from '@pretto/bricks/components/layout'
import * as typo from '@pretto/bricks/core/typography'
import ResponsiveSSR from '@pretto/bricks/components/utility/ResponsiveSSR'

import styled from 'styled-components'

export const Ticks = styled.ul`
  @media screen and (min-width: ${breakpoints.mobileM}) {
    display: flex;
    align-items: center;
  }
`
export const Tick = styled.li`
  ${typo.caption12};
  display: flex;
  align-items: center;
  white-space: nowrap;

  @media screen and (min-width: ${breakpoints.mobileM}) {
    & + & {
      margin-left: ${g(2)};
    }
  }
`
export const TickExtension = styled(ResponsiveSSR).attrs({ min: 'tablet' })`
  margin-left: 3px;
`
